import { render, staticRenderFns } from "./View.vue?vue&type=template&id=b0a840fa&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0a840fa')) {
      api.createRecord('b0a840fa', component.options)
    } else {
      api.reload('b0a840fa', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=b0a840fa&", function () {
      api.rerender('b0a840fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Warehouse/orders/adjustment/View.vue"
export default component.exports